import {
	CLASSIC_BACKLOG,
	COMPANY_MANAGED_BACKLOG,
} from '@atlassian/jira-capabilities/src/constants.tsx';

export const classicBacklogCapability = !__SERVER__ ? COMPANY_MANAGED_BACKLOG : CLASSIC_BACKLOG;
